module.exports = __webpack_public_path__ + "static/media/13-15.0726abef.mp3";